import { render, staticRenderFns } from "./NgoCard.vue?vue&type=template&id=4767a301&"
import script from "./NgoCard.vue?vue&type=script&lang=js&"
export * from "./NgoCard.vue?vue&type=script&lang=js&"
import style0 from "./NgoCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports